import { render, staticRenderFns } from "./DvSnilsField.vue?vue&type=template&id=90e19c92&lang=pug"
import script from "./DvSnilsField.vue?vue&type=script&lang=js"
export * from "./DvSnilsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports